import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { TestTypePrerequisite } from "app/api/graph/types";
import { editTestTypePrerequisiteRoute, testTypePrerequisiteRoute } from "app/route/Routes";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { EditTestTypePrerequisiteForm } from "app/component/test-type-prerequisite/EditTestTypePrerequisiteForm";
import { useRouteParams } from "app/route/route";

export const EditTestTypePrerequisiteScreen: FC = () => {
    const { testTypePrerequisiteId } = useRouteParams(editTestTypePrerequisiteRoute);
    const [testTypePrerequisite, setTestTypePrerequisite] = useState<Pick<TestTypePrerequisite, "_id"> | undefined>(
        undefined,
    );

    return testTypePrerequisite ? (
        <Navigate to={testTypePrerequisiteRoute.build({ testTypePrerequisiteId: testTypePrerequisite._id })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editTestTypePrerequisiteRoute} />
                <EditTestTypePrerequisiteForm
                    testTypePrerequisiteId={testTypePrerequisiteId}
                    onUpdate={setTestTypePrerequisite}
                />
            </Container>
        </NavigationScreen>
    );
};
